import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/Hero.css';
// Removed JS background image logic; handled by CSS for responsiveness
import { scrollToSection } from '../utils/scrollToSection';

const Hero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      {/* Hero image only */}
      <section className="hero-section"></section>
      {/* New section for writing and buttons, just above About Loch Lomond */}
      <section className="hero-cta-section">
        <div className="hero-content">
          {/* Frosted glass overlay only behind the text/buttons area */}
          <div className="hero-content-mist" aria-hidden="true"></div>
          <h1 className="hero-title">{t('hero.title')}</h1>
          <p className="hero-subtitle">{t('hero.subtitle')}</p>
          <div className="hero-buttons">
            {/* Button scrolls to contact form and uses translation */}
            <button 
              className="hero-btn primary-btn" 
              onClick={() => scrollToSection('contact')}
              onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { scrollToSection('contact'); } }}
              aria-pressed="false"
              tabIndex={0}
              onTouchStart={e => e.currentTarget.classList.add('pressed')}
              onTouchEnd={e => e.currentTarget.classList.remove('pressed')}
              onMouseDown={e => e.currentTarget.classList.add('pressed')}
              onMouseUp={e => e.currentTarget.classList.remove('pressed')}
              onBlur={e => e.currentTarget.classList.remove('pressed')}
              // British English comment: Ensures button is accessible and gives visual feedback on press
            >
              {t('hero.primaryButton')}
            </button>
            {/* Button scrolls to contact form and uses translation */}
            <button 
              className="hero-btn secondary-btn" 
              onClick={() => scrollToSection('contact')}
              onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { scrollToSection('contact'); } }}
              aria-pressed="false"
              tabIndex={0}
              onTouchStart={e => e.currentTarget.classList.add('pressed')}
              onTouchEnd={e => e.currentTarget.classList.remove('pressed')}
              onMouseDown={e => e.currentTarget.classList.add('pressed')}
              onMouseUp={e => e.currentTarget.classList.remove('pressed')}
              onBlur={e => e.currentTarget.classList.remove('pressed')}
              // British English comment: Ensures button is accessible and gives visual feedback on press
            >
              {t('hero.secondaryButton')}
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero; 